module.exports = __webpack_public_path__ + "assets/img/29_205_big.af7f1ff1.jpg";